const getPeriod = (period) => {
  let data = {
    "1D": "return_1d",
    "1M": "return_1m",
    "6M": "return_6m",
    "1Y": "return_1y",
    "3Y": "return_3y",
    "5Y": "return_5y",
  }
  return data[period]
}


export {
  getPeriod,
}
